import EmbedInlineStory from './embed-inline-story'
import EmbedInlineStoryQuery from './embed-inline-story.query'

export { EmbedInlineStoryQuery }

export default EmbedInlineStory
